module.exports = __webpack_public_path__ + "static/media/pause-button.913ec28f.svg";